<script setup lang="ts">
  // "Caja y efectivo" card: the parent builds the section (neutral session
  // facts + manual movements + bridge sentences); stale open sessions from
  // previous days hide behind a collapsed toggle so they never bury real
  // data.
  import { ref } from 'vue';
  import { IDayCloseReportSection } from './day-close-report.types';
  import V2DayCloseSectionCard from './V2DayCloseSectionCard.vue';

  defineProps<{
    section: IDayCloseReportSection;
    /** Preformatted stale open sessions ({label} + {window}). */
    staleSessions: Array<{ key: string; label: string; window: string }>;
  }>();

  const showStale = ref(false);
</script>

<template>
  <V2DayCloseSectionCard :section="section">
    <template #after-rows>
      <div v-if="staleSessions.length" class="stale-sessions">
        <button
          type="button"
          class="stale-toggle"
          @click="showStale = !showStale"
        >
          <i
            class="stale-toggle-icon mdi"
            :class="showStale ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          />
          {{
            $t('v2Stats.dayClose.staleSessionsToggle', {
              n: staleSessions.length,
            })
          }}
        </button>
        <div v-if="showStale" class="stale-list">
          <div
            v-for="session in staleSessions"
            :key="session.key"
            class="stale-row"
          >
            <span class="stale-name">{{ session.label }}</span>
            <span class="stale-window">{{ session.window }}</span>
          </div>
        </div>
      </div>
    </template>
  </V2DayCloseSectionCard>
</template>

<style scoped lang="scss">
  .stale-sessions {
    @apply tw-mt-2 tw-border-0 tw-border-t tw-border-solid tw-border-neutral-100 tw-pt-2;

    .stale-toggle {
      @apply tw-flex tw-items-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm tw-font-medium tw-text-neutral-500;

      &:focus-visible {
        @apply tw-outline-none tw-ring-2 tw-ring-orange-500/40;
      }

      .stale-toggle-icon {
        @apply tw-mr-1 tw-text-base;
      }
    }

    .stale-list {
      @apply tw-mt-1;

      .stale-row {
        @apply tw-flex tw-items-baseline tw-justify-between tw-py-1 tw-pl-5;

        .stale-name {
          @apply tw-mr-4 tw-text-sm tw-text-neutral-500;
        }

        .stale-window {
          @apply tw-whitespace-nowrap tw-text-sm tw-text-neutral-400;
        }
      }
    }
  }
</style>
